import React from 'react';

import TimeLimitedDiscount from '../TimeLimitedDiscount/TimeLimitedDiscount';

const ModuleTimeLimitedDiscount = ({
  home,
  primaryColor,
  uiVariantCountdown,
  uiVariantThumbnail,
}) => {
  return (
    <div className="container">
      <TimeLimitedDiscount
        {...home.timeLimitedDiscount}
        primaryColor={primaryColor}
        uiVariantCountdown={uiVariantCountdown}
        uiVariantThumbnail={uiVariantThumbnail}
      />
    </div>
  );
};

export default ModuleTimeLimitedDiscount;
